import React from "react";

import { IgTypography } from "@intelligems/ig-theme/IgTypography";

export interface HeaderProps {
  children?: React.ReactNode;
}

export const Header = ({ children }: HeaderProps) => {
  return <IgTypography fontWeight={600}>{children}</IgTypography>;
};
